import React, { useState } from 'react';
import { FileTextIcon, UserIcon, PlusIcon, BuildingIcon, LayersIcon, TagIcon, ScaleIcon, RulerIcon, DatabaseIcon, AlertCircleIcon, InfoIcon, GridIcon } from 'lucide-react';
export const DataDefinitionsSettings = () => {
  return <div className="space-y-8" data-id="element-577">
      {/* Jurisdiction Definitions */}
      <div className="border-b border-gray-200 pb-8" data-id="element-578">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-579">
          Jurisdiction Hierarchy
        </h3>
        <div className="space-y-4" data-id="element-580">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-581">
            {[{
            level: 1,
            name: 'Region',
            example: 'Oromia, Amhara'
          }, {
            level: 2,
            name: 'Zone',
            example: 'East Shewa, North Shewa'
          }, {
            level: 3,
            name: 'Woreda',
            example: 'Adama, Bishoftu'
          }, {
            level: 4,
            name: 'Kebele',
            example: '01, 02'
          }].map(level => <div key={level.level} className="p-4 border border-gray-200 rounded-md" data-id="element-582">
                <div className="flex items-center justify-between mb-2" data-id="element-583">
                  <span className="text-sm font-medium text-gray-900" data-id="element-584">
                    Level {level.level}: {level.name}
                  </span>
                  <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-585">
                    Edit
                  </button>
                </div>
                <p className="text-xs text-gray-500" data-id="element-586">
                  Example: {level.example}
                </p>
              </div>)}
          </div>
          <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-587">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-588" />
            Add Jurisdiction Level
          </button>
        </div>
      </div>
      {/* Property Classifications */}
      <div className="border-b border-gray-200 pb-8" data-id="element-589">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-590">
          Property Classifications
        </h3>
        <div className="space-y-6" data-id="element-591">
          {/* Property Types */}
          <div data-id="element-592">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-593">
              Property Types & Categories
            </label>
            <div className="space-y-4" data-id="element-594">
              {[{
              type: 'Residential',
              subtypes: ['Single Family', 'Apartment', 'Villa'],
              count: 156
            }, {
              type: 'Commercial',
              subtypes: ['Office', 'Retail', 'Restaurant'],
              count: 89
            }, {
              type: 'Industrial',
              subtypes: ['Factory', 'Warehouse', 'Workshop'],
              count: 45
            }].map(item => <div key={item.type} className="p-4 border border-gray-200 rounded-md" data-id="element-595">
                  <div className="flex items-center justify-between mb-2" data-id="element-596">
                    <span className="text-sm font-medium text-gray-900" data-id="element-597">
                      {item.type}
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-598">
                      {item.count} properties
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-599">
                    {item.subtypes.map(subtype => <span key={subtype} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-600">
                        {subtype}
                      </span>)}
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-601">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-602">
                      Edit
                    </button>
                    <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-603">
                      Add Subtype
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-604">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-605" />
                Add Property Type
              </button>
            </div>
          </div>
          {/* Property Statuses */}
          <div data-id="element-606">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-607">
              Property Statuses
            </label>
            <div className="space-y-2" data-id="element-608">
              {[{
              name: 'Active',
              color: 'green'
            }, {
              name: 'Under Construction',
              color: 'yellow'
            }, {
              name: 'Vacant',
              color: 'gray'
            }, {
              name: 'Under Dispute',
              color: 'red'
            }].map(status => <div key={status.name} className="flex items-center justify-between p-3 border border-gray-200 rounded-md" data-id="element-609">
                  <div className="flex items-center" data-id="element-610">
                    <span className={`w-2 h-2 rounded-full bg-${status.color}-500 mr-2`} data-id="element-611"></span>
                    <span className="text-sm text-gray-900" data-id="element-612">{status.name}</span>
                  </div>
                  <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-613">
                    Edit
                  </button>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-614">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-615" />
                Add Status
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Taxpayer Classifications */}
      <div className="border-b border-gray-200 pb-8" data-id="element-616">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-617">
          Taxpayer Classifications
        </h3>
        <div className="space-y-4" data-id="element-618">
          {[{
          type: 'Individual',
          description: 'Personal property owners',
          attributes: ['National ID', 'TIN']
        }, {
          type: 'Business',
          description: 'Commercial entities',
          attributes: ['Business License', 'TIN']
        }, {
          type: 'Government',
          description: 'Government entities',
          attributes: ['Agency Code', 'Budget Code']
        }, {
          type: 'Non-Profit',
          description: 'Non-profit organizations',
          attributes: ['Registration Number', 'Tax Exemption ID']
        }].map(type => <div key={type.type} className="p-4 border border-gray-200 rounded-md" data-id="element-619">
              <div className="flex items-center justify-between mb-2" data-id="element-620">
                <span className="text-sm font-medium text-gray-900" data-id="element-621">
                  {type.type}
                </span>
                <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-622">
                  Edit
                </button>
              </div>
              <p className="text-sm text-gray-600 mb-2" data-id="element-623">{type.description}</p>
              <div className="flex flex-wrap gap-2" data-id="element-624">
                {type.attributes.map(attr => <span key={attr} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-625">
                    {attr}
                  </span>)}
              </div>
            </div>)}
          <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-626">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-627" />
            Add Taxpayer Type
          </button>
        </div>
      </div>
      {/* Assessment & Appeals */}
      <div className="border-b border-gray-200 pb-8" data-id="element-628">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-629">
          Assessment & Appeals
        </h3>
        <div className="space-y-6" data-id="element-630">
          {/* Valuation Methods */}
          <div data-id="element-631">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-632">
              Valuation Methods
            </label>
            <div className="space-y-4" data-id="element-633">
              {[{
              name: 'Market Value',
              description: 'Based on comparable property sales'
            }, {
              name: 'Income Approach',
              description: 'Based on potential rental income'
            }, {
              name: 'Cost Approach',
              description: 'Based on construction/replacement cost'
            }].map(method => <div key={method.name} className="p-4 border border-gray-200 rounded-md" data-id="element-634">
                  <div className="flex items-center justify-between mb-2" data-id="element-635">
                    <span className="text-sm font-medium text-gray-900" data-id="element-636">
                      {method.name}
                    </span>
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-637">
                      Configure
                    </button>
                  </div>
                  <p className="text-sm text-gray-600" data-id="element-638">{method.description}</p>
                </div>)}
            </div>
          </div>
          {/* Appeal Reason Codes */}
          <div data-id="element-639">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-640">
              Appeal Reason Codes
            </label>
            <div className="space-y-2" data-id="element-641">
              {[{
              code: 'VAL-001',
              reason: 'Incorrect Property Size'
            }, {
              code: 'VAL-002',
              reason: 'Incorrect Property Classification'
            }, {
              code: 'VAL-003',
              reason: 'Market Value Dispute'
            }, {
              code: 'VAL-004',
              reason: 'Condition Assessment Dispute'
            }].map(reason => <div key={reason.code} className="flex items-center justify-between p-3 border border-gray-200 rounded-md" data-id="element-642">
                  <div data-id="element-643">
                    <span className="text-sm font-medium text-gray-900" data-id="element-644">
                      {reason.code}
                    </span>
                    <span className="text-sm text-gray-600 ml-2" data-id="element-645">
                      {reason.reason}
                    </span>
                  </div>
                  <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-646">
                    Edit
                  </button>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-647">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-648" />
                Add Appeal Reason
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Financial Classifications */}
      <div className="border-b border-gray-200 pb-8" data-id="element-649">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-650">
          Financial Classifications
        </h3>
        <div className="space-y-6" data-id="element-651">
          {/* Exemption Types */}
          <div data-id="element-652">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-653">
              Exemption & Relief Types
            </label>
            <div className="space-y-4" data-id="element-654">
              {[{
              type: 'Senior Citizen Relief',
              percentage: '25%'
            }, {
              type: 'Disability Exemption',
              percentage: '100%'
            }, {
              type: 'Agricultural Land',
              percentage: '50%'
            }, {
              type: 'Heritage Property',
              percentage: '75%'
            }].map(exemption => <div key={exemption.type} className="p-4 border border-gray-200 rounded-md" data-id="element-655">
                  <div className="flex items-center justify-between mb-2" data-id="element-656">
                    <span className="text-sm font-medium text-gray-900" data-id="element-657">
                      {exemption.type}
                    </span>
                    <span className="px-2 py-1 text-xs bg-green-100 text-green-800 rounded-full" data-id="element-658">
                      {exemption.percentage}
                    </span>
                  </div>
                  <div className="flex justify-end" data-id="element-659">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-660">
                      Configure
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-661">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-662" />
                Add Exemption Type
              </button>
            </div>
          </div>
          {/* Penalty Types */}
          <div data-id="element-663">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-664">
              Penalty Types
            </label>
            <div className="space-y-4" data-id="element-665">
              {[{
              name: 'Late Payment',
              rate: '2% per month'
            }, {
              name: 'Non-Declaration',
              rate: '25% one-time'
            }, {
              name: 'Incorrect Information',
              rate: '10% one-time'
            }].map(penalty => <div key={penalty.name} className="p-4 border border-gray-200 rounded-md" data-id="element-666">
                  <div className="flex items-center justify-between mb-2" data-id="element-667">
                    <span className="text-sm font-medium text-gray-900" data-id="element-668">
                      {penalty.name}
                    </span>
                    <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full" data-id="element-669">
                      {penalty.rate}
                    </span>
                  </div>
                  <div className="flex justify-end" data-id="element-670">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-671">
                      Configure
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-672">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-673" />
                Add Penalty Type
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Service Definitions */}
      <div className="border-b border-gray-200 pb-8" data-id="element-674">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-675">
          Service Definitions
        </h3>
        <div className="space-y-6" data-id="element-676">
          {/* Service Categories */}
          <div data-id="element-677">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-678">
              Service Categories & Types
            </label>
            <div className="space-y-4" data-id="element-679">
              {[{
              category: 'Waste Management',
              services: ['Residential Collection', 'Commercial Collection', 'Special Waste'],
              unit: 'Per Bin'
            }, {
              category: 'Water Supply',
              services: ['Residential Supply', 'Commercial Supply', 'Industrial Supply'],
              unit: 'Cubic Meter'
            }, {
              category: 'Property Services',
              services: ['Title Transfer', 'Boundary Survey', 'Property Inspection'],
              unit: 'Per Service'
            }].map(category => <div key={category.category} className="p-4 border border-gray-200 rounded-md" data-id="element-680">
                  <div className="flex items-center justify-between mb-2" data-id="element-681">
                    <span className="text-sm font-medium text-gray-900" data-id="element-682">
                      {category.category}
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-683">
                      Unit: {category.unit}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2 mb-3" data-id="element-684">
                    {category.services.map(service => <span key={service} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-685">
                        {service}
                      </span>)}
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-686">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-687">
                      Edit
                    </button>
                    <button className="text-sm text-blue-600 hover:text-blue-700" data-id="element-688">
                      Add Service
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-689">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-690" />
                Add Service Category
              </button>
            </div>
          </div>
          {/* Units of Measurement */}
          <div data-id="element-691">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-692">
              Units of Measurement
            </label>
            <div className="space-y-2" data-id="element-693">
              {[{
              name: 'Area',
              base: 'Square Meter',
              alternatives: ['Square Foot', 'Hectare']
            }, {
              name: 'Volume',
              base: 'Cubic Meter',
              alternatives: ['Liter', 'Gallon']
            }, {
              name: 'Length',
              base: 'Meter',
              alternatives: ['Kilometer', 'Foot']
            }].map(unit => <div key={unit.name} className="p-3 border border-gray-200 rounded-md" data-id="element-694">
                  <div className="flex items-center justify-between mb-2" data-id="element-695">
                    <span className="text-sm font-medium text-gray-900" data-id="element-696">
                      {unit.name}
                    </span>
                    <span className="text-xs text-gray-500" data-id="element-697">
                      Base: {unit.base}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-698">
                    {unit.alternatives.map(alt => <span key={alt} className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-699">
                        {alt}
                      </span>)}
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-700">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-701" />
                Add Unit Type
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Custom Fields */}
      <div className="pt-8" data-id="element-702">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-703">
          Custom Field Definitions
        </h3>
        <div className="space-y-6" data-id="element-704">
          {/* Property Custom Fields */}
          <div data-id="element-705">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-706">
              Property Custom Fields
            </label>
            <div className="space-y-4" data-id="element-707">
              {[{
              name: 'Construction Year',
              type: 'Number',
              required: true,
              visible: true
            }, {
              name: 'Renovation Status',
              type: 'Dropdown',
              required: false,
              visible: true
            }, {
              name: 'Historical Significance',
              type: 'Text',
              required: false,
              visible: true
            }].map(field => <div key={field.name} className="p-4 border border-gray-200 rounded-md" data-id="element-708">
                  <div className="flex items-center justify-between mb-2" data-id="element-709">
                    <span className="text-sm font-medium text-gray-900" data-id="element-710">
                      {field.name}
                    </span>
                    <div className="flex items-center space-x-2" data-id="element-711">
                      {field.required && <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full" data-id="element-712">
                          Required
                        </span>}
                      <span className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-713">
                        {field.type}
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-714">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-715">
                      Configure
                    </button>
                    <button className="text-sm text-red-600 hover:text-red-700" data-id="element-716">
                      Remove
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-717">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-718" />
                Add Custom Field
              </button>
            </div>
          </div>
          {/* Taxpayer Custom Fields */}
          <div data-id="element-719">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-720">
              Taxpayer Custom Fields
            </label>
            <div className="space-y-4" data-id="element-721">
              {[{
              name: 'Preferred Contact Method',
              type: 'Dropdown',
              required: true,
              visible: true
            }, {
              name: 'Alternative Address',
              type: 'Text',
              required: false,
              visible: true
            }, {
              name: 'Special Instructions',
              type: 'TextArea',
              required: false,
              visible: false
            }].map(field => <div key={field.name} className="p-4 border border-gray-200 rounded-md" data-id="element-722">
                  <div className="flex items-center justify-between mb-2" data-id="element-723">
                    <span className="text-sm font-medium text-gray-900" data-id="element-724">
                      {field.name}
                    </span>
                    <div className="flex items-center space-x-2" data-id="element-725">
                      {field.required && <span className="px-2 py-1 text-xs bg-red-100 text-red-800 rounded-full" data-id="element-726">
                          Required
                        </span>}
                      <span className="px-2 py-1 text-xs bg-gray-100 text-gray-600 rounded" data-id="element-727">
                        {field.type}
                      </span>
                    </div>
                  </div>
                  <div className="flex justify-end space-x-2" data-id="element-728">
                    <button className="text-sm text-gray-500 hover:text-gray-700" data-id="element-729">
                      Configure
                    </button>
                    <button className="text-sm text-red-600 hover:text-red-700" data-id="element-730">
                      Remove
                    </button>
                  </div>
                </div>)}
              <button className="w-full flex items-center justify-center px-4 py-2 border-2 border-dashed border-gray-300 rounded-md text-sm text-gray-600 hover:border-gray-400 hover:text-gray-700" data-id="element-731">
                <PlusIcon className="h-4 w-4 mr-2" data-id="element-732" />
                Add Custom Field
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>;
};